module.exports = __webpack_public_path__ + "static/media/bf.48eb94de.svg";